import Vue from 'vue';
import Vuex from 'vuex';
import { listProjects } from '@/api/project';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    projects: [],
    currentProject: null
  },
  mutations: {
    setProjects(state, list) {
      state.projects = list;
    },
    setCurrentProject(state, project) {
      state.currentProject = project;
    },
    updateProject(state, updated) {
      const idx = state.projects.findIndex(p => p.id === updated.id);
      if (idx !== -1) {
        Vue.set(state.projects, idx, { ...state.projects[idx], ...updated });
      }
    },
    removeProject(state, id) {
      state.projects = state.projects.filter(p => p.id !== id);
    }
  },
  actions: {
    async loadProjects({ commit }, params) {
      try {
        const res = await listProjects(params);
        const list = (res.rows || []).map(item => ({
          ...item,
          updatedAt: item.updateTime ? item.updateTime.substring(0, 16) : ''
        }));
        commit('setProjects', list);
      } catch (e) {
        commit('setProjects', []);
      }
    }
  }
});
